import { render } from "./OtherVoucher.vue?vue&type=template&id=353a5396&scoped=true&ts=true"
import script from "./OtherVoucher.vue?vue&type=script&lang=ts"
export * from "./OtherVoucher.vue?vue&type=script&lang=ts"

import "./OtherVoucher.vue?vue&type=style&index=0&id=353a5396&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/medix_envato_v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353a5396"]])

export default __exports__